import type { CallReply } from '../calls/types';

// Only a fresh, successful call_list reply can release a crashed busy owner.
// In particular, a disconnected signalling channel is not proof of no call.
export function confirmsNoCall(reply: CallReply, userId: number): boolean {
  return reply.successful === true && Array.isArray(reply.calls) &&
    reply.calls.every(call => Array.isArray(call.participants) &&
      !call.participants.includes(userId) &&
      !(call.callerId === userId && call.status === 'ringing'));
}
